import global from "./global";
import authentication from "./authentication";
import sidebar from "./sidebar";
import products from "./products";

export default {
  ...authentication,
  ...sidebar,
  ...products,
  ...global
};
